import fetch from '@/utils/fetch'

/* 商家入駐 */

// 獲取縣市
export function getArea (params = {}) {
  return fetch({
    url: '/espier/address',
    method: 'get',
    params: params
  })
}

// 商家分類列表
export function getMerchantsClassification (params = {}) {
  return fetch({
    url: '/merchant/type/list',
    method: 'get',
    params: params
  })
}
//新增商家分類
export function addMerchantsClassification (params = {}) {
  return fetch({
    url: '/merchant/type/create',
    method: 'post',
    params: params
  })
}

// 編輯商家分類
export function editMerchantsClassification (id, params = {}) {
  return fetch({
    url: `/merchant/type/${id}`,
    method: 'put',
    params
  })
}

// 刪除商家分類
export function deleteMerchantsClassification (id) {
  return fetch({
    url: `/merchant/type/${id}`,
    method: 'delete'
  })
}

//獲取商家基礎配置
export function getShopConfig () {
  return fetch({
    url: '/merchant/basesetting',
    method: 'get'
  })
}
// b儲存商家基礎設定
export function saveShopConfig (params) {
  return fetch({
    url: '/merchant/basesetting',
    method: 'post',
    params
  })
}

// 新增/更新 商家
export function addTheBusinessman (params, id) {
  return fetch({
    url: `/merchant${id ? `/${id}` : ''}`,
    method: 'post',
    params
  })
}

// 商戶入駐申請列表
export function getApplicationListForMerchantEntry (params = {}) {
  return fetch({
    url: `/merchant/settlement/apply/list`,
    method: 'get',
    params
  })
}

// 商戶賬號管理列表
export function getMerchantAccountList (params = {}) {
  return fetch({
    url: '/merchant/operator',
    method: 'get',
    params
  })
}

// 獲取商戶詳情
export function getTheMerchant (params, id) {
  return fetch({
    url: `/merchant/detail/${id}`,
    method: 'get',
    params
  })
}

//更新商戶的商品稽核狀態
export function setCommodityAudit (params, id) {
  return fetch({
    url: `/merchant/auditgoods/update/${id}`,
    method: 'post',
    params
  })
}
export function setMerchantsState (params, id) {
  return fetch({
    url: `/merchant/disabled/update/${id}`,
    method: 'post',
    params
  })
}

// 重設商戶密碼
export function setChangePassword (id) {
  return fetch({
    url: `/merchant/operator/${id}`,
    method: 'put'
  })
}

// 商戶入駐詳情
export function merchantsInDetail (id) {
  return fetch({
    url: `/merchant/settlement/apply/${id}`,
    method: 'get'
  })
}

// 稽核商戶入駐
export function setCheckTheEntryOfMerchants (params = {}) {
  return fetch({
    url: `/merchant/settlement/apply/audit`,
    method: 'post',
    params
  })
}

// 商家端獲取商戶資訊
export function getTheMerchantInfo () {
  return fetch({
    url: '/merchant/info',
    method: 'get'
  })
}
export function updateTheMerchantInfo (params = {}) {
  return fetch({
    url: '/merchant/operator',
    method: 'post',
    params
  })
}

// 獲取商戶型別
export function getMerchantsType (params) {
  return fetch({
    url: '/merchant/visibletype/list',
    method: 'get',
    params
  })
}

// 獲取商戶列表
export function getMerchantsList (params) {
  return fetch({
    url: '/merchant/list',
    method: 'get',
    params
  })
}
